import { useState, useEffect } from 'react';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import {
  Products,
  ProductsInterface,
} from 'domains/Catalog/Subscriptions/components/Products';
import { MetaplanFormProps } from '../MetaplanForm';

interface ScopeSelectorProps
  extends Pick<MetaplanFormProps, 'values' | 'errors' | 'onChangeProducts'> {
  disabled?: boolean;
  excludedProductIds?: string[];
}

export function ScopeSelector({
  values: { productIds },
  errors,
  disabled = false,
  onChangeProducts,
  excludedProductIds = [],
}: Readonly<ScopeSelectorProps>) {
  const t = useTranslationCatalog();
  const errorProducts = errors?.productIds || errors?.['productIds'] || '';

  const [productsWithNames, setProductsWithNames] = useState<
    ProductsInterface[]
  >([]);

  useEffect(() => {
    setProductsWithNames((prevProducts) => {
      const prevIds = new Set(prevProducts.map((p) => p.id));
      const newIds = new Set(productIds);

      if (
        prevIds.size === newIds.size &&
        [...prevIds].every((id) => newIds.has(id))
      ) {
        return prevProducts;
      }

      return productIds.map((id) => {
        const existing = prevProducts.find((p) => p.id === id);
        return existing || { id, description: `Product ${id}` };
      });
    });
  }, [productIds]);

  const handleChange = (updatedProducts: ProductsInterface[]) => {
    setProductsWithNames(updatedProducts);
    const updatedProductIds = updatedProducts.map((p) => p.id);
    onChangeProducts(updatedProductIds);
  };

  return (
    <Products
      products={productsWithNames}
      requiredText={errorProducts ? t(errorProducts) : ''}
      onChange={handleChange}
      selectLinkText={t('subscriptions.form.products.selector.select')}
      editLinkText={t('subscriptions.form.products.selector.edit')}
      disabled={disabled}
      excludedProductIds={excludedProductIds}
    />
  );
}
